if (!customElements.get('nn-category-browser')) {
  customElements.define('nn-category-browser', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.panels = [...this.querySelectorAll('[data-category-panel]')];
      this.frames = new Map();
      this.panels.forEach(panel => {
        const rail = panel.querySelector('[data-product-rail]');
        if (!rail) return;
        rail.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frames.get(panel));
          this.frames.set(panel, requestAnimationFrame(() => this.updateControls(panel)));
        }, { ...options, passive: true });
        [-1, 1].forEach(direction => {
          panel.querySelector(direction < 0 ? '[data-browse-prev]' : '[data-browse-next]').addEventListener('click', () => {
            const cards = [...rail.children];
            const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : rail.clientWidth;
            const distance = step * Math.max(1, Math.floor(rail.clientWidth / step));
            rail.scrollBy({ left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          }, options);
        });
      });
      this.observer = new ResizeObserver(entries => {
        entries.forEach(entry => this.updateControls(entry.target.closest('[data-category-panel]')));
      });
      this.panels.forEach(panel => {
        const rail = panel.querySelector('[data-product-rail]');
        if (rail) this.observer.observe(rail);
      });
      this.panels.forEach(panel => this.updateControls(panel));
    }
    updateControls(panel) {
      if (!panel || panel.hidden) return;
      const rail = panel.querySelector('[data-product-rail]');
      if (!rail) return;
      const controls = panel.querySelector('[data-browse-controls]');
      const max = rail.scrollWidth - rail.clientWidth;
      controls.hidden = max <= 2;
      panel.querySelector('[data-browse-prev]').disabled = rail.scrollLeft <= 2;
      panel.querySelector('[data-browse-next]').disabled = rail.scrollLeft >= max - 2;
      const bounds = rail.getBoundingClientRect();
      const cards = [...rail.children];
      const visible = cards.map((card, i) => {
        const rect = card.getBoundingClientRect();
        return rect.right > bounds.left + 12 && rect.left < bounds.right - 12 ? i + 1 : 0;
      }).filter(Boolean);
      if (!visible.length) return;
      const label = `${visible[0]}–${visible.at(-1)} of ${cards.length}`;
      const counter = panel.querySelector('[data-browse-count]');
      if (counter.textContent !== label) counter.textContent = label;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.frames?.forEach(frame => cancelAnimationFrame(frame));
    }
  });
}
